module.exports = __webpack_public_path__ + "static/16-b0ab5ae9d752db5a2d1c29fa3bda7b0b.jpg";